/** 保留原文，只标记“属（Latin）”中的拉丁属名；不倾斜界、门、纲、目、科。 */
export function taxonomyParts(text: string): { text: string; italic: boolean }[] {
  const parts: { text: string; italic: boolean }[] = [];
  let offset = 0;
  for (const match of text.matchAll(/属(\s*[（(]\s*)([A-Za-z][A-Za-z .-]*)(\s*[）)])/g)) {
    const start = match.index! + 1 + match[1]!.length;
    if (start > offset) parts.push({ text: text.slice(offset, start), italic: false });
    parts.push({ text: match[2]!, italic: true });
    offset = start + match[2]!.length;
  }
  if (offset < text.length) parts.push({ text: text.slice(offset), italic: false });
  return parts;
}
